// The plot area inside the strip card: the outer size minus the padding
// that every layer (band, line, fan, labels) positions against.

export const MOBILE_STRIP_PADDING = { top: 6, right: 10, bottom: 8, left: 8 }

export type StripPlotArea = {
  width: number
  height: number
  padding: typeof MOBILE_STRIP_PADDING
  innerWidth: number
  innerHeight: number
}

export const stripPlotArea = (width: number, height: number): StripPlotArea => ({
  width,
  height,
  padding: MOBILE_STRIP_PADDING,
  innerWidth: width - MOBILE_STRIP_PADDING.left - MOBILE_STRIP_PADDING.right,
  innerHeight: height - MOBILE_STRIP_PADDING.top - MOBILE_STRIP_PADDING.bottom,
})
